export enum device {
    tablet = 1023
}